/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForSecurity extends models.GovernanceConfigurationBase {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForSecurity.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForSecurity>): GovernanceConfigurationBaseForSecurity {
        let obj = Object.assign(new GovernanceConfigurationBaseForSecurity(), model);
        GovernanceConfigurationBaseForSecurity.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForSecurity>): GovernanceConfigurationBaseForSecurity {
        if (!model) return null;
        return GovernanceConfigurationBaseForSecurity.newInstance(<GovernanceConfigurationBaseForSecurity> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForSecurity) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForSecurity.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForSecurity): boolean {
        if (models.GovernanceConfigurationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForSecurity.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.notifications) {
            models.ConfigurationForNotifications.fixupPrototype(this.notifications);
        }
    }

    /**
     * Notifications Settings For Security
     */
    notifications: models.ConfigurationForNotifications;

    /**
     * Specifies whether daily summary notification enabled or not
     */
    enable_daily_summary_notification: boolean;

}
